import React, { Fragment } from 'react';
import './channeling.scss';

const Channeling = props => <Fragment>{props.children}</Fragment>;

export default  Channeling;
